// ============================================================================
// General Application Constants
// ============================================================================

export const DOM_EVENTS = {
  MESSAGE: 'message',
}

// ============================================================================
// IndexedDB Configuration
// ============================================================================
export const IDB_CONFIG = {
  DB_NAME: 'companiesDB',
  DB_VERSION: 1,
  DEFAULT_CACHE_TIME: 30 * 60 * 1000, // 30 minutes
}

// ============================================================================
// Logger Configuration
// ============================================================================
export const LOGGER_COLORS = {
  info: '#2196F3', // Blue
  success: '#4CAF50', // Green
  warning: '#FFC107', // Amber
  error: '#FF5252', // Red
  scope: '#9C27B0', // Purple
  file: '#607D8B', // Blue Grey
}

// ============================================================================
// Authentication & Permissions
// ============================================================================
export const PERMISSION_LEVELS = ['readonly', 'user', 'admin', 'b', 'delete']
